import { useEffect, useRef, useState } from "react";
import { Clock, Briefcase, Users } from "lucide-react";

const stats = [
  {
    icon: Clock,
    value: 18,
    suffix: "",
    label: "Años de Trayectoria",
    description: "Experiencia consolidada en el sector industrial",
  },
  {
    icon: Users,
    value: 20,
    suffix: "+",
    label: "Clientes Corporativos",
    description: "Sectores mineros e industriales de gran escala",
  },
  {
    icon: Briefcase,
    value: 100,
    suffix: "+",
    label: "Proyectos Ejecutados",
    description: "Proyectos completados con estándares técnicos exigentes",
  },
];

function CountUp({ target, suffix, isVisible }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isVisible) return;
    let start = 0;
    const duration = 1800;
    const step = Math.ceil(target / (duration / 16));
    const timer = setInterval(() => {
      start += step;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(start);
      }
    }, 16);
    return () => clearInterval(timer);
  }, [isVisible, target]);

  return (
    <span>
      {count}
      {suffix}
    </span>
  );
}

export default function Stats() {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="bg-slate-800/50 border-y border-slate-700/50 py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-0 divide-y md:divide-y-0 md:divide-x divide-slate-700/50">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div
                key={index}
                className="flex flex-col items-center text-center px-8 py-8 md:py-4 group"
              >
                <div className="bg-orange-500/10 border border-orange-500/20 w-14 h-14 rounded-full flex items-center justify-center mb-5">
                  <Icon className="text-orange-500" size={24} />
                </div>
                <div className="text-5xl font-black text-white mb-2 tabular-nums">
                  <CountUp
                    target={stat.value}
                    suffix={stat.suffix}
                    isVisible={isVisible}
                  />
                </div>
                <p className="text-orange-400 font-bold text-sm uppercase tracking-widest mb-2">
                  {stat.label}
                </p>
                <p className="text-slate-500 text-xs max-w-[180px] leading-relaxed">
                  {stat.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
